// Chakra imports
import {Flex, Grid, useColorModeValue} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {FaCube, FaMoneyBill} from "react-icons/fa";
import {IoDocumentsSharp} from "react-icons/io5";
import Conversations from "./components/Conversations";
import Header from "./components/Header";
import PlatformSettings from "./components/PlatformSettings";
import ProfileInformation from "./components/ProfileInformation";
import Projects from "./components/Projects";
import {fetchSchoolDetail} from "./Services";
import {FILE_BASE_URL} from "../../../constants/ApiConstant";
import ProfileBgImage from "assets/img/ProfileBackground.png";
import PaymentReportTable from "./components/PaymentReportTable";
import {BellTab} from "./components/BellTab";
import SchoolSetupDetail from "./components/SchoolSetup";
import {BellIcon} from "@chakra-ui/icons";

const SS_ACTIVE_TAB = "admin:schoolProfile:activeTab";

function Profile(props) {
    const {selectedSchool} = props;

    // Chakra color mode
    const bgProfile = useColorModeValue(
        "hsla(0,0%,100%,.8)",
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
    );

    const [school, setSchool] = useState({});
    // Restore the last active tab after a refresh; the key is cleared on unmount
    // (i.e. when navigating back to the school list) so a fresh school opens on
    // OVERVIEW.
    const [active, setActive] = useState(
        () => sessionStorage.getItem(SS_ACTIVE_TAB) || "OVERVIEW"
    );

    useEffect(() => {
        fetchSchoolDetails(selectedSchool);
    }, []);

    const setActiveTab = (selected) => {
        setActive(selected);
        sessionStorage.setItem(SS_ACTIVE_TAB, selected);
    }

    const fetchSchoolDetails = async (selectedSchool) => {
        try {
            const response = await fetchSchoolDetail(selectedSchool);
            if (response.status === 200) {
                const data = await response.data;
                console.log("School details : ", data);
                setSchool(data);
            }
        } catch (e) {
            console.error("Error fetching school details : {}", e);
        }
    };

    const renderTabContent = () => {
        console.log("Rendering content for tab:", active); // Debugging the activeTab value
        switch (active) {
            case "OVERVIEW":
                return (
                    <Grid templateColumns={{sm: "1fr", xl: "repeat(3, 1fr)"}} gap="22px">
                        <PlatformSettings
                            title={"Platform Settings"}
                            school={school}
                        />
                        <ProfileInformation
                            title={"School Information"}
                            school={school}
                        />
                        <Conversations
                            selectedSchool={selectedSchool}
                            title={"Users"}
                        />
                    </Grid>
                );
            case "BELL":
                return (<BellTab selectedSchool={selectedSchool}/>);
            case "SETUP":
                return (
                    <SchoolSetupDetail selectedSchool={selectedSchool}/>
                );
            case "PROJECTS":
                return (
                    <Projects title={"Projects"} description={"Architects design houses"}/>
                );
            case "PAYMENTS":
                return (
                    <PaymentReportTable selectedSchool={selectedSchool}/>
                );
            case "ACTIVITY":
                return (
                    <PaymentReportTable/>
                );
            default:
                return null;
        }
    };

    useEffect(() => {
    }, [active]);

    // Verification tier shown as a Golden/Silver tick next to the name.
    // TODO: replace the demo fallback with school?.verificationTier once the
    // backend returns it.
    const schoolVerificationTier =
        school?.verificationTier ||
        ((school?.name || "").trim().length % 2 === 0 ? "gold" : "silver");

    return (
        <Flex direction="column">
            <Header
                backgroundHeader={school?.banner !== "" && school?.banner !== null ? FILE_BASE_URL + "/" + school?.banner : ProfileBgImage}
                backgroundProfile={bgProfile}
                avatarImage={school?.logo}
                name={school?.name}
                verified={schoolVerificationTier}
                email={school?.email}
                code={school?.code || school?.channelCode || school?.schoolCode}
                tabs={[
                    {
                        name: "OVERVIEW",
                        icon: <FaCube/>,
                        onClick: () => setActiveTab("OVERVIEW"), // Set active tab
                    },
                    {
                        name: "BELL",
                        icon: <BellIcon/>,
                        onClick: () => setActiveTab("BELL"), // Set active tab
                    },
                    {
                        name: "SETUP",
                        icon: <IoDocumentsSharp/>,
                        onClick: () => setActiveTab("SETUP"), // Set active tab
                    },
                    {
                        name: "PAYMENTS",
                        icon: <FaMoneyBill/>,
                        onClick: () => setActiveTab("PAYMENTS"), // Set active tab
                    },
                ]}
            />
            <Flex mt={5}>{renderTabContent()}</Flex>
        </Flex>
    );
}

export default Profile;